'use strict';

import _ from 'lodash';

const availablePlanTypes = require('ck-core/source/functions/availablePlanTypes');
const planDurations = require('ck-core/source/data/planDurations');
const planSizes = require('ck-core/source/data/planSizes');

export default function(options) {
	options = _.defaults(options || {}, {});

	let available = availablePlanTypes(
		options.currentPlanType || (options.user ? options.user.currentPlanType() : null)
	);

	if (CK.fn.inTest('CheaperThreeMonthRecurringPlan')) {
		let availableExcludesMonthly = _.filter(
			available,
			planType => planType.duration !== planDurations.MONTHLY
		);

		available = availableExcludesMonthly;
	} else {
		let availableExcludes3Monthly = _.filter(
			available,
			planType => planType.duration !== planDurations.THREE_MONTHLY
		);

		available = availableExcludes3Monthly;
	}

	if (!CK.fn.inTest('12MonthCreditForTests')) {
		let availableExcludesYear = _.filter(
			available,
			planType => planType.duration !== planDurations.YEAR
		);

		available = availableExcludesYear;
	} else {
		let availableExcludesYearly = _.filter(
			available,
			planType => planType.duration !== planDurations.YEARLY
		);

		available = availableExcludesYearly;
	}

	if (options.product) {
		let availableForProduct = _.filter(available, planType => planType.product === options.product);

		available = availableForProduct;
	}

	let size;

	if (options.size) {
		size = options.size;
	} else {
		// Only show plans of one size - whichever has more plans
		const sizeGroups = _.groupBy(available, 'size');

		size = _.maxBy(_.keys(sizeGroups), size => sizeGroups[size]);

		// If there are an equal number of individual and family plans available, show the individual ones
		if (sizeGroups[planSizes.INDIVIDUAL] && _.uniq(_.map(sizeGroups, 'length')).length === 1) {
			size = planSizes.INDIVIDUAL;
		}
	}

	available = _.filter(available, {
		size
	});

	return available;
}
